/**
 * Birthday field matching profile-settings: text input with DD/MM/YYYY auto-formatting.
 * Same UX as ProfileSettingsForm birthday - user types digits, slashes added automatically.
 * Outputs string "DD/MM/YYYY" for Sharetribe privateData.birthday compatibility.
 */
import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';

import { ValidationError } from '../../components';

import css from './FieldBirthdayInput.module.css';

const formatBirthdayInput = value => {
  if (!value || typeof value !== 'string') return '';
  let cleanValue = value.replace(/[^\d]/g, '');
  if (cleanValue.length > 2) {
    cleanValue = `${cleanValue.slice(0, 2)}/${cleanValue.slice(2)}`;
  }
  if (cleanValue.length > 5) {
    cleanValue = `${cleanValue.slice(0, 5)}/${cleanValue.slice(5, 9)}`;
  }
  return cleanValue;
};

const FieldBirthdayInputComponent = props => {
  const { id, label, input, meta, disabled, placeholder, ...rest } = props;
  const { value, onChange, onBlur } = input;
  const { touched, invalid, error } = meta;
  const hasError = touched && invalid && error;

  const handleChange = e => {
    onChange(formatBirthdayInput(e.target.value));
  };

  const inputClasses = classNames(css.input, {
    [css.inputError]: hasError,
  });

  return (
    <div className={css.root}>
      {label ? (
        <label className={css.label} htmlFor={id}>
          {label}
        </label>
      ) : null}
      <input
        id={id}
        type="text"
        className={inputClasses}
        value={value || ''}
        onChange={handleChange}
        onBlur={onBlur}
        placeholder={placeholder}
        maxLength={10}
        disabled={disabled}
        autoComplete="off"
        {...rest}
      />
      <ValidationError fieldMeta={meta} />
    </div>
  );
};

const FieldBirthdayInput = props => {
  const { id, label, name, validate, disabled, placeholder, ...rest } = props;

  return (
    <Field
      component={FieldBirthdayInputComponent}
      id={id}
      label={label}
      name={name}
      validate={validate}
      disabled={disabled}
      placeholder={placeholder}
      {...rest}
    />
  );
};

export default FieldBirthdayInput;
